import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const AiKnowledgeBasePage = () => <SearchLandingPage config={searchLandingPages.aiKnowledgeBase} />;

export default AiKnowledgeBasePage;
